import './setup.js';
import '../styles.css';
import { mountApp } from './App.jsx';

mountApp();
